import React, { Component } from 'react';

import Select from '@material-ui/core/Select';
import FilledInput from '@material-ui/core/FilledInput';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl'

import './topStyle.css';

class TopComponent extends Component { 
    state = {
        group: 'None'
    }    

    handleChangeItem = event => {
        this.setState({ [event.target.name]: event.target.value });
        this.props.onChange(event);
    };
    

    getTotal = () => {
        const {data} = this.props;
        let resp = 0;
        for(let i=0;i<data.length;i++){
            resp += data[i].value;
        }
        return resp;
    }

    getItems = () => {
        return this.props.data.map((val,i) =>{
            return(
                <MenuItem value={i} key={'menuitem-select-' + i}>{val.name}</MenuItem>
            )
        })
          
    }
    

    render (){
        
        return (
            <FormControl variant="filled" style={{width:'100%'}}>
                <Select
                    value={this.state.group}
                    input={<FilledInput name="group" id="filled-age-simple" />}
                    onChange={this.handleChangeItem}
                    style={{margin:'auto'}}
                    className='selector-top'
                    >
                    <MenuItem value="">
                        <em>{this.props.label}</em>
                    </MenuItem>
                    {this.getItems()}
                </Select>
            </FormControl>
        )
    }    
}

export default TopComponent; 